import React from 'react';
import {
	buildTestData,
} from 'Vulture/TestData';
import style from './Slideshow.module.css';
import CustomIcon from '../Common/CustomIcon/CustomIcon';

class VisualContentLoopModal extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			VCLName: props?.loopData?.name ?? '',
		};

		this.loopNameInputRef = React.createRef();
	}

	componentDidMount() {
		if (this.loopNameInputRef?.current) {
			this.loopNameInputRef.current.focus();
		}
	}

	render() {
		const {
			app,
			createOrUpdateLoop,
		} = this.props;

		const {
			VCLName,
		} = this.state;

		return (
			<>
				<div className={style.slideDeckModal}>
					<div className={style.formGroup}>
						<label>
							Visual Content Loop Name<br></br>
							<input
								value={VCLName}
								id='modalVisualContentLoopName'
								type='text'
								placeholder='Visual Content Loop Name'
								ref={this.loopNameInputRef}
								onKeyDown={(e) => {
									if (e.key === 'Enter') {
										e.preventDefault();
										createOrUpdateLoop(VCLName);
										app.closeModal();
									}
								}}
								onChange={(e) => {
									this.setState({
										VCLName: e.target.value,
									});
								}}
								data-test-id="visualContentLoopNameInput"
								data-testing-info={buildTestData('input--visual-content-loop-name')}
							/>  
						</label>
					</div>

					<div className={style.bottom}>
						<button
							onClick={(e) => {
								e.preventDefault();
								createOrUpdateLoop(VCLName);
								app.closeModal();
							}}
							className="button"
							data-test-id="visualContentLoopModalSaveButton"
						>
							<CustomIcon icon='save' /><div>Save</div>
						</button>
					</div>
				</div>
			</>
		);
	}
}

export default VisualContentLoopModal;
